import axios from 'axios';

export const SESSION_EXPIRED_MESSAGE = 'Your session has expired. Please sign in again.';

export function getSessionUser() {
  try {
    return JSON.parse(sessionStorage.getItem('user') || 'null');
  } catch (_) {
    return null;
  }
}

export function getAccessToken() {
  const user = getSessionUser();
  return user && typeof user.accessToken === 'string' ? user.accessToken.trim() : '';
}

export function isAuthenticated() {
  const user = getSessionUser();
  return Boolean(user && user.isLoggedIn && getAccessToken());
}

const apiClient = axios.create({
  baseURL: '/',
});

apiClient.interceptors.request.use((config) => {
  const headers = config.headers || {};
  const currentAuthorization = headers.Authorization || headers.authorization || '';
  const needsToken = !currentAuthorization || /^Bearer\s*$/i.test(currentAuthorization);

  if (needsToken) {
    const accessToken = getAccessToken();
    if (accessToken) {
      headers.Authorization = `Bearer ${accessToken}`;
      delete headers.authorization;
    }
  }

  config.headers = headers;
  return config;
});

let redirectingToLogin = false;

// Sliding session: the backend sends a renewed token while the user is active.
export function storeRefreshedAccessToken(response) {
  const headers = (response && response.headers) || {};
  const refreshed = headers['x-access-token'];
  if (typeof refreshed !== 'string' || !refreshed.trim()) return;
  const user = getSessionUser();
  if (!user || !user.isLoggedIn) return;
  sessionStorage.setItem('user', JSON.stringify({ ...user, accessToken: refreshed.trim() }));
}

apiClient.interceptors.response.use(
  (response) => {
    storeRefreshedAccessToken(response);
    return response;
  },
  (error) => {
    const status = error && error.response && error.response.status;
    const requestUrl = error && error.config && error.config.url;
    const isLoginRequest = typeof requestUrl === 'string' && requestUrl.includes('/api/post/login');
    const hadAuthenticatedSession = isAuthenticated();

    if (status === 401 && !isLoginRequest && hadAuthenticatedSession) {
      sessionStorage.clear();
      sessionStorage.setItem('authMessage', SESSION_EXPIRED_MESSAGE);

      if (!redirectingToLogin && window.location.pathname !== '/') {
        redirectingToLogin = true;
        window.location.replace('/');
      }
    }

    return Promise.reject(error);
  }
);

export default apiClient;
